module.exports = __webpack_public_path__ + "static/media/button-save-btn.1fdebef7.png";